export default __webpack_public_path__ + "static/media/checkbox.40c8987e.svg";